<template>
	<div class="interstitial">
		<div class="interstitial__content">
			<div class="interstitial__about">
				<p class="interstitial__about-text">
					{{ $t('pages.publishers.sections.formats.interstitialContent.about.text1') }}
				</p>
				<p class="interstitial__about-text">
					{{ $t('pages.publishers.sections.formats.interstitialContent.about.text2') }}
				</p>
				<ul class="interstitial__about-list">
					<li
						v-for="(item, i) in $tm('pages.publishers.sections.formats.interstitialContent.about.list')"
						:key="i">
						{{ $rt(item) }}
					</li>
				</ul>
			</div>
			<div class="interstitial__description">
				<div v-for="(block, i) in blocks" :key="i" class="interstitial__description-block">
					<Icon name="lets-icons:check-fill" size="40" />
					<BlocksPublishersFormatTabBlockButtons
						v-if="$rt(block.type) === 'buttons'"
						:block="block"
						:selected-format="selectedFormat"
						@select-format="handleSelectFormat" />
					<BlocksPublishersFormatTabBlockChips v-else-if="$rt(block.type) === 'chips'" :block="block" />
					<BlocksPublishersFormatTabBlockList v-else-if="$rt(block.type) === 'list'" :block="block" />
					<BlocksPublishersFormatTabBlockText v-else-if="$rt(block.type) === 'text'" :block="block" />
				</div>
			</div>
		</div>

		<BlocksPublishersFormatTabInterstitialExample />

		<!-- <BlocksPublishersFormatTabinterstitialExample
			:selected-format="selectedFormat"
			:formats="availableFormats"
			@change-format="handleSelectFormat" /> -->
	</div>
</template>
<script setup lang="ts">
	type InterstitialBlock = {
		type: string
		title?: string
		items?: { title: string; buttons: string[] }[]
		chips?: string[]
		list?: string[]
		text?: string
	}
	const selectedFormat = ref('320×480')

	const handleSelectFormat = (format: string) => {
		selectedFormat.value = format
	}

	const { tm } = useI18n()

	const blocks = computed<InterstitialBlock[]>(
		() => tm('pages.publishers.sections.formats.interstitialContent.blocks') as InterstitialBlock[]
	)
</script>
<style lang="scss" scoped>
	.interstitial {
		display: flex;
		gap: 48px;
		align-items: flex-start;

		@media (width <= 767.98px) {
			flex-direction: column-reverse;
			gap: 24px;
			align-items: center;
		}
		&__content {
			display: flex;
			flex-direction: column;
			gap: 8px;
			// flex: 0 0 50%;
			// max-width: 50%;
			width: 100%;
		}
		&__about {
			display: flex;
			flex-direction: column;
			gap: 8px;
			padding: 24px;
			background-color: var(--white);
			border-radius: 20px;
			&-text {
				font-size: 16px;
			}
			&-list {
				padding-left: 1.5em;
				text-indent: -1.5em;
				list-style-type: disc;
			}
		}
		&__description {
			display: flex;
			flex-direction: column;
			gap: 24px;
			padding: 24px;
			background-color: var(--white);
			border-radius: 20px;
			&-block {
				display: flex;
				gap: 16px;

				@media (width <= 767.98px) {
					flex-direction: column;
					gap: 8px;
				}
				.iconify {
					flex-shrink: 0;
					margin-top: -4px;
					color: var(--primary);

					@media (width <= 767.98px) {
						margin-top: 0;
						margin-left: -8px;
					}
				}
			}
		}
	}
</style>
